function clear(container) {
    while (container.firstChild) {
        container.removeChild(container.firstChild);
    }
}

function matchItem(value, item) {
    let matched =  item.text.startsWith(value);

    if (matched) {
        return matched;
    }

    for (const synonym of item.synonyms) {
        if (synonym.startsWith(value)) {
            return true;
        }
    }

    return false;
}

function templateFrom(templateContainer, data, config = {}) {
    const element = templateContainer.children[0].cloneNode(true);

    if ("addClass" in config) {
        element.classList.add(...config.addClass.split(" "));
    }

    for (const selector in data) {
        element.querySelectorAll(selector)
            .forEach(item => {
                if (typeof data[selector] === "function") {
                    data[selector](item);
                }
                else {
                    item.textContent = data[selector];
                }
            });
    }

    return element;
}

export function initMultiselect(element, config = {}) {
    const target = element.querySelector(".multiselect__items");
    const input = element.querySelector(".multiselect__input");
    const tooltip = element.querySelector(".multiselect__tooltip");
    const source = element.querySelector(".multiselect__source");
    const items = Array.from(element.querySelectorAll(".multiselect__source input"))
        .map(item => ({
            element: item,
            text: item.dataset.text.toLowerCase(),
            value: item.value,
            synonyms: (item.dataset.synonym || "").split(",").map(str => str.toLowerCase())
        }));
    const itemsMap = items.reduce((acc, val) => ({ ...acc, [val.value]: val }), {});
    const templates = Array.from(element.querySelectorAll("[data-template]"))
        .map(template => ({ element: template, name: template.dataset.template }))
        .reduce((acc, val) => ({ ...acc, [val.name]: val.element }), {});
    const messages = {
        notMatch: tooltip.dataset.messageNotMatch || "Нет похожих тегов",
        emptyInput: tooltip.dataset.messageEmptyInput || "Начинайте вводить тег"
    };
    const renderedItems = {};
    const performSearch = () => {
        clear(tooltip);
        const matchedItems = items.filter(item => {
            return (!input.value || matchItem(input.value.toLowerCase(), item)) && !item.element.checked;
        });

        if (matchedItems.length) {
            matchedItems.forEach(item => tooltip.appendChild(templateFrom(templates.tooltipItem, {
                    "span": (span) => {
                        span.textContent = item.element.dataset.text;
                        span.parentElement.dataset.value = item.value;
                    }
                })));
        }
        else {
            const isEmpty = !input.value.length;

            tooltip.appendChild(templateFrom(templates.tooltipItem, {
                "span": isEmpty ? messages.emptyInput : messages.notMatch
            }, {
                addClass: "disabled " + (isEmpty ? "empty" : "unmatch")
            }));
        }
    };
    const pushItemElement = (item, withTrigger = false) => {
        const renderedItem = templateFrom(templates.item, {
            ".mutliselect__item-text": (span) => {
                span.textContent = item.element.dataset.text;
                span.parentElement.dataset.value = item.value;
            }
        });

        renderedItems[item.value] = renderedItem;
        target.appendChild(renderedItem);
        element.classList.remove("error");

        if (withTrigger) {
            element.dispatchEvent(new CustomEvent("multiselect.change", {
                detail: {
                    type: "add",
                    value: item.value,
                    text: item.element.dataset.text
                }
            }));
        }

    };
    const createItem = (value, text, synonyms = "") => {
        if (value in itemsMap) {
            addItem(value, false);
        }
        else {
            const input = document.createElement("input");
            input.type = "checkbox";
            input.name = config.name;
            input.value = value;
            input.setAttribute("data-text", text);
            source.appendChild(input);

            const element = {
                element: input,
                text: text.toLowerCase(),
                value: value,
                synonyms: synonyms
            };
            items.push(element);
            itemsMap[value] = element;

            addItem(value);
        }
    };
    const addItem = (value, withTrigger) => {
        if (value in itemsMap && !itemsMap[value].element.checked) {
            const item = itemsMap[value];
            item.element.checked = true;
            pushItemElement(item, withTrigger);
        }
    };
    const removeItem = (value, withTrigger = false) => {
        if (value in itemsMap && itemsMap[value].element.checked) {
            const item = itemsMap[value];
            item.element.checked = false;
            renderedItems[value].parentNode.removeChild(renderedItems[value]);
            delete renderedItems[value];

            if (withTrigger) {
                element.dispatchEvent(new CustomEvent("multiselect.change", {
                    detail: {
                        type: "remove",
                        value: value
                    }
                }));
            }
        }
    };
    const keySelect = (delta) => {
        if (tooltip.querySelector(".disabled")) {
            return;
        }

        const children = tooltip.children;
        const current = tooltip.querySelector(".selected");
        const index = Array.prototype.indexOf.call(children, current);
        let nextIndex = 0;

        if (index !== -1) {
            nextIndex = index + delta;

            if (nextIndex < 0) {
                nextIndex = children.length - 1;
            }
            else if (nextIndex > children.length - 1) {
                nextIndex = 0;
            }
        }

        if (current) {
            current.classList.remove("selected");
        }

        const target = children[nextIndex];

        if (target) {
            target.classList.add("selected");
            target.scrollIntoView({
                block: "center"
            });
        }
    };
    const selectCurrent = () => {
        const children = tooltip.children;
        const current = tooltip.querySelector(".selected");

        if (current) {
            let index = Array.prototype.indexOf.call(children, current);
            
            addItem(current.dataset.value, true);
            performSearch();

            index = Math.min(children.length - 1, index);

            if (children.length && !tooltip.querySelector(".disabled")) {
                children[index].classList.add("selected");
            }
        }
    };
    const onInput = config.provider ? (e) => {
        if (e.target.value) {
            performSearch();

            tooltip.appendChild(templateFrom(templates.loader));

            config.provider(e.target.value)
                .then((arr) => {
                    arr.filter(({ value }) => !(value in itemsMap))
                        .forEach(item => {
                            const input = document.createElement("input");
            
                            input.type = "checkbox";
                            input.name = element.dataset.name;
                            input.value = item.value;
                            input.dataset.text = item.text;
                            input.dataset.synonym = item.synonym;

                            const newItem = {
                                element: input,
                                text: input.dataset.text.toLowerCase(),
                                value: input.value,
                                synonyms: (input.dataset.synonym || "").split(",").map(str => str.toLowerCase())
                            };

                            items.push(newItem);
                            itemsMap[item.value] = newItem;
            
                            source.appendChild(input);
                        });
                    performSearch();
                });
        }
        else {
            performSearch();
        }
    } : performSearch;

    if (!input.readOnly) {
        input.addEventListener("focus", () => { element.classList.add("opened"); performSearch() });
        input.addEventListener("blur", () => element.classList.remove("opened"));
        input.addEventListener("input", onInput);
        input.addEventListener("keydown", e => {
            switch (e.key) {
                case "ArrowDown":
                    e.preventDefault();
                    keySelect(1);
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    keySelect(-1);
                    break;
                case "Enter":
                    e.preventDefault();
                    selectCurrent();
                    break;
                case "Escape":
                    e.preventDefault();
                    input.blur();
                    break;
            }
        });
    }

    tooltip.addEventListener("mousedown", e => {
        e.preventDefault();

        let element = e.target.closest(".multiselect__tooltip-item:not(.disabled)");

        if (element && element.dataset.value) {
            addItem(element.dataset.value, true);
            performSearch();
        }
    });
    target.addEventListener("click", e => {
        let element = null;

        if (element = e.target.closest(".multiselect__item-remove")) {
            const container = element.parentElement;

            removeItem(container.dataset.value, true);
        }
    });
    items.filter(item => item.element.checked)
        .forEach(item => pushItemElement(item));

    return {
        element, element,
        add: addItem,
        remove: removeItem,
        create: createItem
    };
}

export function init(container = document) {
    container.querySelectorAll(".multiselect:not(.delayed)")
        .forEach(initMultiselect);
}
